import { create } from "zustand";
import { reactLocalStorage } from "reactjs-localstorage";
import { UserAIIntegration } from "../configs/WebService";
import {
  userLocalSessionKey,
  userDefOrgLocalStorageKey,
} from "../configs/User.config";

const staticUser = {
  email_id: "aleem.ghufran@spaplc.con",
  id: 3185,
  name: "Ghunfran Aleem",
  token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIzMTg1IiwiaXNzIjoib3JnYW5pc2F0aW9uIiwic2Vzc2lvbklkIjoiNjUyNkFCQTYxREI2NEJBRkI1RTI3NEMyMzM5NkM3OTIiLCJpYXQiOjE3NTg3ODE4ODQsImV4cCI6MTc1ODg2ODI4NH0.-u7bhK_8xHcJMQoKioun_FSxmH0JHfpCu4-qqpecxqxOOCy2lT4MAxj6uKS2me7VabHvrQhSB7gErQc2g4MJ7A",
  loginTimeStamp: 1758781884218,
  role: { code: "aprvr", name: "Approver", id: 12 },
  org: {
    id: 26,
    name: "IT DocMaster Org test",
    address: "Hanamkonda",
    city: "Godavarikhani test04",
    state: 1,
    pincode: "505209",
    landmark: "one shopping mall",
    country: 1,
    email: null,
    contactNo: null,
    status: 0,
    createdBy: 4,
    updatedBy: 3168,
    createdOn: 1723631683000,
    updatedOn: 1752906864000,
    expireOn: 1973609313000,
    userId: null,
  },
  mobile_no: "9701021984",
  type: { id: 3, title: "Organizational User" },
  orgModuleAccess: {
    user: 1,
    probInfo: 1,
    client: 1,
    clientCase: 1,
    research: 1,
    fileMerge: 1,
    feeCal: 1,
  },
  is_mobile_verify: 1,
  is_email_verify: 1,
  status: 0,
  isLoggedIn: true,
};


/*
  This will help with state Management of LoggedIn User
*/
//  const userData = reactLocalStorage.getObject(userLocalSessionKey);
const modelsKey = "user_models_list";
const selectedModelKey = "user_selected_model_id";
const userStore = create((set) => ({
  user: reactLocalStorage.getObject(userLocalSessionKey),
  // user: staticUser,
  // userDefaultOrg: reactLocalStorage.getObject(userDefOrgLocalStorageKey),
  setUser: (userData) => {
    reactLocalStorage.setObject(userLocalSessionKey, userData);
    set((state) => ({ user: userData }));
  },
  removeUser: () => {
    reactLocalStorage.remove(userLocalSessionKey);
    // reactLocalStorage.remove(userDefOrgLocalStorageKey);
    reactLocalStorage.clear();
    window.localStorage.clear();
    set((state) => ({
      user: reactLocalStorage.getObject(userLocalSessionKey),
    }));
  },
  // setUserDefaultOrg: (orgData) => {
  //   reactLocalStorage.setObject(userDefOrgLocalStorageKey, orgData);
  //   set((state) => ({ userDefaultOrg: orgData }));
  // },

  //For User ai credentials
  models: Array.isArray(reactLocalStorage.getObject(modelsKey)) ? reactLocalStorage.getObject(modelsKey) : [],
  selectedModelId: reactLocalStorage.get(selectedModelKey) || null,

  setUser: (userData) => {
    reactLocalStorage.setObject(userLocalSessionKey, userData);
    set((state) => ({ user: userData }));
  },
  removeUser: () => {
    reactLocalStorage.remove(userLocalSessionKey);
    // reactLocalStorage.remove(userDefOrgLocalStorageKey);
    reactLocalStorage.remove(modelsKey);
    reactLocalStorage.remove(selectedModelKey);
    reactLocalStorage.clear();
    window.localStorage.clear();
    set((state) => ({
      user: reactLocalStorage.getObject(userLocalSessionKey),
      models: [],
      selectedModelId: null,
    }));
  },

  //ai model list
  setModels: (models) => {
    reactLocalStorage.setObject(modelsKey, models);
    set(() => ({ models }));
  },

  // New: set selected model
  setSelectedModelId: (id) => {
    reactLocalStorage.set(selectedModelKey, id);
    set(() => ({ selectedModelId: id }));
  },

  // setUserDefaultOrg: (orgData) => {
  //   reactLocalStorage.setObject(userDefOrgLocalStorageKey, orgData);
  //   set((state) => ({ userDefaultOrg: orgData }));
  // },

  fetchUserModels: async (userId) => {
    try {
      const response = await fetch(
        `${UserAIIntegration}/userAIModel/${userId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch models");
      }

      const result = await response.json();
      const data = result.data; // <- Important: get 'data' array

      // Map it to your internal format (if you want to rename keys)
      const mappedModels = data.map((item) => ({
        model_id: item.ai_id,
        name: item.ai_model_name,
        verified: item.verified,
        verified_at: item.verified_at,
      }));

      reactLocalStorage.setObject(modelsKey, mappedModels);
      set(() => ({ models: mappedModels }));

      // Optionally set selected id (first one)
      if (mappedModels.length > 0) {
        const firstModelId = mappedModels[0].model_id;
        reactLocalStorage.set(selectedModelKey, firstModelId);
        set(() => ({ selectedModelId: firstModelId }));
      }
    } catch (error) {
      console.error("Error fetching user models:", error);
    }
  },

}));

export default userStore;
